import { ReactElement } from 'react';
import { Typography, Box } from '@mui/material';
import { Line as LineChart } from 'react-chartjs-2';

import LoadingFallback from '~components/LoadingFallback';

import { useReportsVisitsSectionContext } from '../../Context';

import { ReportsVisitsSectionChartsWrapperChart } from '../styles';

import { getHistoricalDemandForRoutedOrdersChartProps } from './utils';

const ReportsVisitsSectionChartsHistoricalDemandForRoutedOrders =
  (): ReactElement => {
    const {
      data: {
        statistic: { data: statisticData, loading: loadingStatisticsData },
      },
    } = useReportsVisitsSectionContext();

    return (
      <ReportsVisitsSectionChartsWrapperChart>
        <Typography variant="body1" component="h4" fontWeight="bold">
          Demanda histórica de pedidos ruteados
        </Typography>

        {loadingStatisticsData && <LoadingFallback />}

        {!loadingStatisticsData && statisticData && (
          <Box maxHeight={302}>
            <LineChart
              {...getHistoricalDemandForRoutedOrdersChartProps({
                previousYearVisitCompleted:
                  statisticData.previousYearVisitTotalCount,
                currentYearVisitCompleted:
                  statisticData.currentYearVisitTotalCount,
              })}
            />
          </Box>
        )}
      </ReportsVisitsSectionChartsWrapperChart>
    );
  };

export default ReportsVisitsSectionChartsHistoricalDemandForRoutedOrders;
